import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
//  Avatar,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  LinearProgress,
  Button, 
  IconButton, 
} from '@material-ui/core';

import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

//import { getInitials } from 'helpers';

import { IsNoU } from 'common/utils';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  rowIcons: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    //paddingLeft: theme.spacing(8),
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const DeviceTable = props => {
  const { 
    className, 
    userRole,
    type,
    devices, 
    logs,
    errors,
    histories,
    modems,
    mhistories,
    onSetSelectedDevices,
    onClickOpenRegister,
    onClickOpenEdit,
    onClickOpenDelete,
    disableEditButton,
    disableDeleteButton,

    onClickOpenUploadDialog,
    onClickOpenDownloadDialog,

    openProgress,
    page,
    rowsPerPage,
    item_total,
    onPageChange,
    onRowsPerPageChange,

    ...rest 
  } = props;

  

  const classes = useStyles();

  const [selectedDevices, setSelectedDevices] = useState([]);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [page, setPage] = useState(0);

  const handleSelectAll = event => {

    let selectedDevices;

    if (type === 'manage') {
      if (event.target.checked) {
        selectedDevices = devices.map(device => device.id);
      } else {
        selectedDevices = [];
      }
    }
    else if (type === 'modem') {
      if (event.target.checked) {
        selectedDevices = modems.map(modem => modem.id);
      } else {
        selectedDevices = [];
      }
    }

    setSelectedDevices(selectedDevices);
    onSetSelectedDevices(selectedDevices);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedDevices.indexOf(id);
    let newSelectedDevices = [];

    if (selectedIndex === -1) {
      newSelectedDevices = newSelectedDevices.concat(selectedDevices, id);
    } else if (selectedIndex === 0) {
      newSelectedDevices = newSelectedDevices.concat(selectedDevices.slice(1));
    } else if (selectedIndex === selectedDevices.length - 1) {
      newSelectedDevices = newSelectedDevices.concat(selectedDevices.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedDevices = newSelectedDevices.concat(
        selectedDevices.slice(0, selectedIndex),
        selectedDevices.slice(selectedIndex + 1)
      );
    }

    setSelectedDevices(newSelectedDevices);
    onSetSelectedDevices(newSelectedDevices);
  };

  // const handlePageChange = (event, page) => {
  //   setPage(page);
  // };

  // const handleRowsPerPageChange = event => {
  //   setRowsPerPage(event.target.value);
  // };

  return (
    <div>

      { userRole !== 'user' && (type === 'manage' || type === 'modem') && (
        <div className={classes.row}>
          <Button
            color="primary"
            variant="contained"
            onClick={ onClickOpenRegister }
          >
            등록
          </Button>

          <Button
            color="primary"
            variant="contained"
            disabled={ disableEditButton }
            onClick={ onClickOpenEdit }
          >
            수정
          </Button>

          <Button
            style={{
              //  borderRadius: 35,
                backgroundColor: disableDeleteButton ? "#DCDBDC" : "#E00000",
                color: disableDeleteButton ? "#A6A6A6":"#FFFFFF"
                // padding: "18px 36px",
                // fontSize: "18px"
              }}
            variant="contained"
            disabled={ disableDeleteButton }
            onClick={ onClickOpenDelete }
          >
            삭제
          </Button>

          <div className={classes.rowIcons}>
            <IconButton
              arai-label="view"
              onClick={onClickOpenUploadDialog}
            >
                <CloudUploadIcon />
            </IconButton>

            <IconButton
              arai-label="view"
              onClick={onClickOpenDownloadDialog}
            >
                <CloudDownloadIcon />
            </IconButton>
          </div>

        </div>
       )
      }
      {(type === 'logs' || type === 'errors' || type === 'history' || type === 'mhistory') &&
        (
          <div className={classes.rowIcons}>
            <IconButton
              onClick={onClickOpenDownloadDialog}
            >
                <CloudDownloadIcon />
            </IconButton>
          </div>
        )
      }
      <Card
        {...rest}
        className={clsx(classes.root, className)}
      >
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <div className={classes.inner}>
              {openProgress && <LinearProgress /> }
              {type === 'manage' &&
              (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={devices.length > 0 && selectedDevices.length === devices.length}
                          color="primary"
                          indeterminate={
                            selectedDevices.length > 0 &&
                            selectedDevices.length < devices.length
                          }
                          onChange={handleSelectAll}
                        />
                      </TableCell>
                      <TableCell>번호</TableCell>
                      <TableCell>모델명</TableCell>
                      <TableCell>시리얼NO</TableCell>
                      <TableCell>디바이스현황 / 상태</TableCell>
                      {/* <TableCell>디바이스상태</TableCell> */}
                      <TableCell>전화번호</TableCell>
                      <TableCell>택시회사명</TableCell>
                      <TableCell>차량번호</TableCell>
                      <TableCell>수정일</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {devices.slice(0, rowsPerPage).map((device, index) => (
                      <TableRow
                        className={classes.tableRow}
                        hover
                        key={device.id}
                        selected={selectedDevices.indexOf(device.id) !== -1}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={selectedDevices.indexOf(device.id) !== -1}
                            color="primary"
                            onChange={event => handleSelectOne(event, device.id)}
                            value="true"
                          />
                        </TableCell>
                        <TableCell>{index}</TableCell>
                        <TableCell>
                          <div className={classes.nameContainer}>
                            {/* <Avatar
                              className={classes.avatar}
                              src={category.avatarUrl}
                            >
                              {getInitials(category.name)}
                            </Avatar> */}
                            <Typography variant="body1">{device.name}</Typography>
                          </div>
                        </TableCell>
                        <TableCell>{device.serial_no}</TableCell>
                        <TableCell>{device.status} / {device.installed}</TableCell>
                        {/* <TableCell>{device.installed}</TableCell> */}
                        <TableCell>{device.phone_number}</TableCell>
                        <TableCell>{device.company}</TableCell>
                        <TableCell>{device.car_number}</TableCell>
                        <TableCell>{moment(device.modified_at).format('YYYY-MM-DD')}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )
              }

              { type === 'logs' &&
              (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>번호</TableCell>
                      <TableCell>택시회사명</TableCell>
                      <TableCell>차량번호</TableCell>
                      <TableCell>시리얼No</TableCell>
                      <TableCell>상태</TableCell>
                      <TableCell>일시</TableCell>
                      <TableCell>결과</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {logs.slice(0, rowsPerPage).map((log, index) => (
                      <TableRow
                        className={classes.tableRow}
                        hover
                        key={log.id}
                        //selected={selectedDevices.indexOf(device.id) !== -1}
                      >
                        <TableCell>{index}</TableCell>
                        <TableCell>
                          <div className={classes.nameContainer}>
                            {/* <Avatar
                              className={classes.avatar}
                              src={category.avatarUrl}
                            >
                              {getInitials(category.name)}
                            </Avatar> */}
                            <Typography variant="body1">{log.company}</Typography>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={classes.nameContainer}>
                            {/* <Avatar
                              className={classes.avatar}
                              src={category.avatarUrl}
                            >
                              {getInitials(category.name)}
                            </Avatar> */}
                            <Typography variant="body1">{log.car_number}</Typography>
                          </div>
                        </TableCell>
                        <TableCell>{log.serial_no}</TableCell>
                        <TableCell>
                        {
                          !IsNoU(log.gps_latitude) && !IsNoU(log.gps_longitude) ? 'GPS' : 
                          !IsNoU(log.power) ? log.power ? '부팅' : '종료' :
                          !IsNoU(log.campaign) ? log.campaign ? '캠패인(성공)' : '캠패인(실패)' :
                          ''
                        }
                        </TableCell>
                        <TableCell>{moment(log.log_at).format('YYYY-MM-DD HH:mm:ss')}</TableCell>
                        <TableCell>{log.result ? '성공' : '실패'}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )
              }

              {type === 'errors' && (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>번호</TableCell>
                      <TableCell>시리얼No</TableCell>
                      <TableCell>택시회사명</TableCell>
                      <TableCell>차량번호</TableCell>
                      <TableCell>미접속일</TableCell>
                      <TableCell>발생일</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {errors.slice(0, rowsPerPage).map((err, index) => (
                      <TableRow
                        className={classes.tableRow}
                        hover
                        key={err.id}
                        //selected={selectedDevices.indexOf(device.id) !== -1}
                      >
                        <TableCell>{index}</TableCell>
                        <TableCell>{err.serial_no}</TableCell>
                        <TableCell>
                          <div className={classes.nameContainer}>
                            {/* <Avatar
                              className={classes.avatar}
                              src={category.avatarUrl}
                            >
                              {getInitials(category.name)}
                            </Avatar> */}
                            <Typography variant="body1">{err.company}</Typography>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={classes.nameContainer}>
                            {/* <Avatar
                              className={classes.avatar}
                              src={category.avatarUrl}
                            >
                              {getInitials(category.name)}
                            </Avatar> */}
                            <Typography variant="body1">{err.car_number}</Typography>
                          </div>
                        </TableCell>
                        <TableCell>{err.error_days}일</TableCell>
                        <TableCell>{moment(err.reg_at).format('YYYY-MM-DD')}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}

              {type === 'history' && (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>번호</TableCell>
                      <TableCell>시리얼No</TableCell>
                      <TableCell>디바이스현황</TableCell>
                      <TableCell>디바이스상태</TableCell>
                      <TableCell>택시회사명</TableCell>
                      <TableCell>차량번호</TableCell>
                      <TableCell>수정일</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {histories.slice(0, rowsPerPage).map((history, index) => (
                      <TableRow
                        className={classes.tableRow}
                        hover
                        key={history.id}
                        //selected={selectedDevices.indexOf(device.id) !== -1}
                      >
                        <TableCell>{index}</TableCell>
                        <TableCell>{history.serial_no}</TableCell>
                        <TableCell>{history.status}</TableCell>
                        <TableCell>{history.installed}</TableCell>
                        <TableCell>{history.company}</TableCell>
                        <TableCell>{history.car_number}</TableCell>
                        <TableCell>{moment(history.modified_at).format('YYYY-MM-DD')}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}

              {type === 'modem' &&
              (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={devices.length > 0 && selectedDevices.length === devices.length}
                          color="primary"
                          indeterminate={
                            selectedDevices.length > 0 &&
                            selectedDevices.length < devices.length
                          }
                          onChange={handleSelectAll}
                        />
                      </TableCell>
                      <TableCell>번호</TableCell>
                      <TableCell>모델명</TableCell>
                      <TableCell>모뎀시리얼NO</TableCell>
                      <TableCell>통신회사</TableCell>
                      <TableCell>모뎀현황</TableCell>
                      <TableCell>디바이스시리얼NO</TableCell>
                      <TableCell>등록자</TableCell>
                      <TableCell>등록일</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {modems.slice(0, rowsPerPage).map((modem, index) => (
                      <TableRow
                        className={classes.tableRow}
                        hover
                        key={modem.id}
                        selected={selectedDevices.indexOf(modem.id) !== -1}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={selectedDevices.indexOf(modem.id) !== -1}
                            color="primary"
                            onChange={event => handleSelectOne(event, modem.id)}
                            value="true"
                          />
                        </TableCell>
                        <TableCell>{index}</TableCell>
                        <TableCell>
                          <div className={classes.nameContainer}>
                            {/* <Avatar
                              className={classes.avatar}
                              src={category.avatarUrl}
                            >
                              {getInitials(category.name)}
                            </Avatar> */}
                            <Typography variant="body1">{modem.name}</Typography>
                          </div>
                        </TableCell>
                        <TableCell>{modem.serial_no}</TableCell>
                        <TableCell>{modem.telecom}</TableCell>
                        <TableCell>{modem.status}</TableCell>
                        <TableCell>{modem.device_serial_no}</TableCell>
                        <TableCell>{modem.reg_user}</TableCell>
                        <TableCell>{moment(modem.reg_at).format('YYYY-MM-DD')}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )
              }

              {type === 'mhistory' &&
              (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>번호</TableCell>
                      <TableCell>모델명</TableCell>
                      <TableCell>시리얼No</TableCell>
                      <TableCell>모뎀현황</TableCell>
                      <TableCell>모뎀상태</TableCell>
                      <TableCell>디바이스시리얼NO</TableCell>
                      <TableCell>수정일</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {mhistories.slice(0, rowsPerPage).map((mhistory, index) => (
                      <TableRow
                        className={classes.tableRow}
                        hover
                        key={mhistory.id}
                        //selected={selectedDevices.indexOf(device.id) !== -1}
                      >
                        <TableCell>{index}</TableCell>
                        <TableCell>{mhistory.name}</TableCell>
                        <TableCell>{mhistory.serial_no}</TableCell>
                        <TableCell>{mhistory.status}</TableCell>
                        <TableCell>{mhistory.installed}</TableCell>
                        <TableCell>{mhistory.device_serial_no}</TableCell>
                        <TableCell>{moment(mhistory.reg_at).format('YYYY-MM-DD')}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )
              }
            </div>
          </PerfectScrollbar>
        </CardContent>
        {/* {type === 'manage' ? */}
          <CardActions className={classes.actions}>
            <TablePagination
              labelRowsPerPage=''
              component="div"
              count={item_total}
              onChangePage={onPageChange}
              onChangeRowsPerPage={onRowsPerPageChange}
              page={page}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[5, 10, 25]}
            />
          </CardActions>
        {/* } */}
        {/* {type === 'logs' ?
          <CardActions className={classes.actions}>
            <TablePagination
              labelRowsPerPage=''
              component="div"
              count={logs.length}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handleRowsPerPageChange}
              page={page}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[5, 10, 25]}
            />
          </CardActions>
          :
          ('')
        }
        {type === 'errors' ?
          <CardActions className={classes.actions}>
            <TablePagination
              labelRowsPerPage=''
              component="div"
              count={errors.length}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handleRowsPerPageChange}
              page={page}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[5, 10, 25]}
            />
          </CardActions>
          :
          ('')
        }
        {type === 'history' ?
          <CardActions className={classes.actions}>
            <TablePagination
              labelRowsPerPage=''
              component="div"
              count={histories.length}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handleRowsPerPageChange}
              page={page}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[5, 10, 25]}
            />
          </CardActions>
          :
          ('')
        }
        {type === 'modem' ?
          <CardActions className={classes.actions}>
            <TablePagination
              labelRowsPerPage=''
              component="div"
              count={modems.length}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handleRowsPerPageChange}
              page={page}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[5, 10, 25]}
            />
          </CardActions>
          :
          ('')
        }
        {type === 'mhistory' ?
          <CardActions className={classes.actions}>
            <TablePagination
              labelRowsPerPage=''
              component="div"
              count={mhistories.length}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handleRowsPerPageChange}
              page={page}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[5, 10, 25]}
            />
          </CardActions>
          :
          ('')
        } */}
      </Card>

    </div>
  );
};

DeviceTable.propTypes = {
  className: PropTypes.string,
  devices: PropTypes.array.isRequired,
  logs: PropTypes.array.isRequired,
  errors: PropTypes.array.isRequired,
  histories: PropTypes.array.isRequired,
  modems: PropTypes.array.isRequired,
  mhistories: PropTypes.array.isRequired,
};

export default DeviceTable;
